import NextImage, { type ImageProps } from "next/image";

export default function Image(props: ImageProps) {
  // https://developers.cloudflare.com/images/image-resizing/integration-with-frameworks
  return <NextImage {...props} />;
}
